import { OnInit, OnDestroy, Directive } from '@angular/core';
import { Subscription, Observable, NEVER } from 'rxjs';
import { EventsService, EventsServiceManager } from './events.service';
import { tap, catchError } from 'rxjs/operators';
import { UnauthorizedError } from './http.service';
import { MessageEvent } from './message-event.service';

@Directive()
export abstract class SingletonEntityDetailsComponent<E>
  implements OnInit, OnDestroy {
  protected subscription: Subscription = new Subscription();
  protected eventsService: EventsService<MessageEvent>;

  item$: Observable<E>;

  loading = false;
  unauthorized = false;

  constructor(eventsServiceManager: EventsServiceManager) {
    this.eventsService = eventsServiceManager.get('content.messages', { message: '', status: 'success' });
  }

  protected abstract loadEntity(): Observable<E>;

  protected handleEntityLoaded(entity: E) {
    // no-op
  }

  ngOnInit() {
    this.loading = true;
    this.item$ = this.loadEntity().pipe(
      catchError((error: Error) => {
        if (error instanceof UnauthorizedError) {
          this.unauthorized = true;
        }
        this.loading = false;
        return NEVER;
      }),
      tap((entity: E) => {
        this.handleEntityLoaded(entity);
        this.loading = false;
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
